import { useEffect, useState } from 'react';
import { warehouseAuthAPI, WarehouseUser, useAuthenticateMutation } from 'api';

interface UseWarehouseAuthReturn {
  user: WarehouseUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
}

export const useWarehouseAuth = (): UseWarehouseAuthReturn => {
  const [user, setUser] = useState<WarehouseUser | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error] = useState<string | null>(null);
  const [authenticate] = useAuthenticateMutation();

  // Call authenticate API on mount (same as ERP)
  useEffect(() => {
    authenticate();
  }, [authenticate]);

  // Check if user is authenticated on mount
  useEffect(() => {
    const initAuth = () => {
      try {
        const savedUser = warehouseAuthAPI.getCurrentUser();

        if (savedUser) {
          setUser(savedUser);
        }
      } catch (error) {
        console.error('Failed to initialize warehouse auth:', error);
      } finally {
        setIsLoading(false);
      }
    };

    initAuth();
  }, []);

  return {
    user,
    isAuthenticated: !!user,
    isLoading,
    error,
  };
};
